import React from "react";
import ArrowRightFromBaseIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowRightFromBaseIconPath";
import {
  useGivenName,
  useSurname,
  useRoleId,
  useUID,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { capitalizeFirst } from "@coworker/app/src/hooks/useFormatter";
import { displayRoleTranslationString } from "../../../../shared/helpers/user.helper";
import styles from "./profile-header.module.css";
import { Trans } from "@coworker/locales";
import { Avatar } from "../../../../shared/components/Avatar/Avatar";
import { FixaText } from "../../../../shared/wrappers/FixaText/FixaText";
import FixaButton from "../../../../shared/wrappers/FixaButton/FixaButton";
import { UserRoles } from "../../../../shared/enums/user/userRoles";
import { useMsal } from "@azure/msal-react";

export const ProfileHeader: React.FC = () => {
  const firstName = useGivenName();
  const lastName = useSurname();
  const roleId = useRoleId();
  const uid = useUID();

  const fullName = [firstName, lastName].map(capitalizeFirst).join(" ");
  const { instance } = useMsal();
  React.useState(false);
  const onLogout = async () => {
    await instance.logoutRedirect();
  };
  return (
    <div className={styles["profile-header"]}>
      <div>
        <Avatar isBigImage={true} uid={uid} />
      </div>
      <div className={styles["profile-header-info"]}>
        <FixaText tagName="h2" textStyle="Heading.S">
          {fullName}
        </FixaText>
        <FixaText
          tagName="h3"
          textStyle="Body.S"
          className={styles["text-gap"] as string}
        >
          <Trans>{displayRoleTranslationString(roleId as UserRoles)}</Trans>
        </FixaText>
        <FixaButton
          type="secondary"
          key="logOutButton"
          text={<Trans>logoutString</Trans>}
          size="small"
          fluid={true}
          onClick={onLogout}
          ssrIcon={ArrowRightFromBaseIconPath}
          iconPosition="trailing"
        ></FixaButton>
      </div>
    </div>
  );
};
